export const POLYGON_TOKEN_WHITELIST = [
    '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270'
]
export const POLYGON_TOKEN_BLACKLIST = []